// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__Od9E7","header":"ReportDetails_header__14rTA","title":"ReportDetails_title__2OOz7","left":"ReportDetails_left__1MNCC"};